export default {
  colors: {
    globalBlack100: '#000000',
    globalWhite100: '#FFFFFF',
    brandPrimary10: '#E9E7F8',
    brandPrimary20: '#D7D3F3',
    brandPrimary30: '#B3ABE8',
    brandPrimary40: '#8F83DD',
    brandPrimary60: '#5947CD',
    brandPrimary70: '#4935C3',
    brandPrimary100: '#332588',
    brandSecondary70: '#EB0054',
    brandSecondary80: '#c40147',
    primary10: '#EAE8FD',
    primary20: '#D6D1FA',
    primary30: '#C1BAF8',
    primary40: '#ADA3F6',
    primary50: '#988BF4',
    primary60: '#8374F1',
    primary70: '#4935C3',
    primary80: '#5A46ED',
    primary90: '#462FEA',
    primary100: '#3118E8',
    secondary10: '#FAE5EC',
    secondary20: '#F4CCD9',
    secondary30: '#EFB3C7',
    secondary40: '#EA99B4',
    secondary50: '#FF337C',
    secondary60: '#DF668E',
    secondary70: '#DA4C7C',
    secondary80: '#D53369',
    secondary90: '#CF1C58',
    secondary100: '#CA0043',
    neonPurple10: '#F1ECFF',
    neonPurple20: '#E4D9FF',
    neonPurple30: '#D6C6FF',
    neonPurple40: '#C9B3FF',
    neonPurple50: '#BB9FFF',
    neonPurple60: '#AE8CFF',
    neonPurple70: '#A079FF',
    neonPurple80: '#9266FF',
    neonPurple90: '#8553FF',
    neonPurple100: '#7740FF',
    purple10: '#ECEBF5',
    purple20: '',
    purple30: '',
    purple40: '',
    purple50: '#6B5BD2',
    purple60: '',
    purple70: '',
    purple80: '#4230B0',
    purple90: '#5848A7',
    purple100: '#45349D',
    darkPurple10: '',
    darkPurple20: '',
    darkPurple30: '',
    darkPurple40: '',
    darkPurple50: '',
    darkPurple60: '',
    darkPurple70: '',
    darkPurple80: '',
    darkPurple90: '',
    darkPurple100: '',
    neutral300: '#E2E6E9',
    neutralDark10: '#E9E9EB',
    neutralDark20: '#D2D4D6',
    neutralDark30: '#BCBFC2',
    neutralDark40: '#A6A9AD',
    neutralDark50: '#8F9399',
    neutralDark60: '#797E85',
    neutralDark70: '#636970',
    neutralDark80: '#4D535C',
    neutralDark90: '#363E47',
    neutralDark100: '#202833',
    neutralGray5: '#F2F2F2',
    neutralGray10: '#E6E6E6',
    neutralGray20: '#CCCCCC',
    neutralGray40: '#999999',
    neutralGray50: '#808080',
    neutralGray60: '#666666',
    neutralGray70: '#4D4D4D',
    neutralGray80: '#333333',
    neutralGray90: '#191919',
    neutralGray100: '#080808',
    neutralSilver5: '#F8F9FA',
    neutralSilver10: '#E3E6EC',
    neutralSilver20: '#D1D6E0',
    neutralSilver30: '#B6BCC8',
    neutralSilver40: '#9DA4B2',
    neutralSilver50: '#838A9A',
    neutralSilver60: '#717888',
    neutralSilver70: '#595F6D',
    neutralSilver80: '#444954',
    neutralSilver90: '#30353F',
    neutralSilver100: '#1F2227',
    neutralLight10: '#F5F7F9',
    neutralLight20: '#ECEFF2',
    neutralLight30: '',
    neutralLight40: '',
    neutralLight50: '',
    neutralLight60: '',
    neutralLight70: '',
    neutralLight80: '',
    neutralLight90: '',
    neutralLight100: '',
    statusInfo10: '#E2ECF3',
    statusInfo50: '#155284',
    statusSuccess10: '#E1EDE6',
    statusSuccess20: '#53BA80',
    statusSuccess30: '#1F844B',
    statusSuccess40: '#196B3D',
    statusSuccess50: '#13532F',
    statusDanger20: '#E48181',
    statusDanger30: '#D53E3E',
    statusDanger40: '#C92B2B',
    statusDanger50: '#AA1D1D',
    statusWarning10: '#F1E9DF',
    statusWarning20: '#E09846',
    statusWarning50: '#78460D',
    savingsClubGreen: '#00C48C',
    savingsClubBlack900: '#1A1A1A',
    blackTints400: '#999999',
    shadowStatusHover: '#323247',
    globalBlack: '#121212',
    appStoreGrey: '#474747',
    googlePlayGrey: '#A6A6A6',
    storesGray: '#303437',
  },
} as const;
